/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { lockCustomerContracts } from '../fn/locking/lock-customer-contracts';
import { LockCustomerContracts$Params } from '../fn/locking/lock-customer-contracts';

@Injectable({ providedIn: 'root' })
export class LockingService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `lockCustomerContracts()` */
  static readonly LockCustomerContractsPath = '/svgs/{svgId}/customers/{customerId}/lock-customer-contracts';

  /**
   * Lock all customer contracts.
   *
   * Locks all contracts of a customer. Without changing a debit return. This is a general lock all contracts endpoint.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `lockCustomerContracts()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  lockCustomerContracts$Response(params: LockCustomerContracts$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return lockCustomerContracts(this.http, this.rootUrl, params, context);
  }

  /**
   * Lock all customer contracts.
   *
   * Locks all contracts of a customer. Without changing a debit return. This is a general lock all contracts endpoint.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `lockCustomerContracts$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  lockCustomerContracts(params: LockCustomerContracts$Params, context?: HttpContext): Observable<void> {
    return this.lockCustomerContracts$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
